var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "alert-group-status-app" } },
    [
      _c("v-container", { staticClass: "alert-group-status-container" }, [
        _c(
          "div",
          {
            class: _vm.vueTableClass,
            attrs: { id: _vm.vueTableID, "data-app": "true" },
          },
          [
            _c("alert-filters", {
              attrs: {
                breakdowns: _vm.breakdowns,
                "button-enabled": false,
                "pref-key": "_" + _vm.alertId,
              },
              on: { "alert-filters": _vm.updateFilters },
            }),
            _vm._v(" "),
            _c("vy-table", {
              ref: "alertGroupStatusTable",
              attrs: {
                columns: _vm.columns,
                "table-data": _vm.tableData,
                "show-edit": false,
                "disable-row-selection": true,
                filter: _vm.filter,
                layout: "fitDataFill",
                height: _vm.tableHeight,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }